import { Component, Input } from '@angular/core';
import { IBreadcrumbItem } from './typings/bread-brumb-item';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'pandora-breadcrumbs',
    imports: [
        RouterLink,
    ],
    templateUrl: './breadcrumbs.component.html',
    styleUrl: './breadcrumbs.component.scss',
})
export class BreadcrumbsComponent {

    @Input()
    items: IBreadcrumbItem[] = [];

}
